/** Transaction origin of every local edit: the only origin the undo manager tracks. */
export const LOCAL_ORIGIN = Symbol('os-local');

/** Transaction origin of automatic repairs (orphans, cycles): never tracked by undo, so a repair cannot be undone. */
export const REPAIR_ORIGIN = Symbol('os-repair');

/** Transaction origin of a version restore (spec §11.1): never tracked by undo, so a restore cannot be undone locally. */
export const RESTORE_ORIGIN = Symbol('os-restore');

/** Transaction origin of a board seeded from a file or a duplicate (P9): never tracked by undo. */
export const SEED_ORIGIN = Symbol('os-seed');
